import { mapGetters, mapActions } from 'vuex'
import publisher from '@/api/publisher'
export default {
  components: {},
  data() {
    return {
      isShow: true,
      params: {
        emailList: '',
        emailLists: []
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      publisherId: 'getPublisherId',
      publisherInfo: 'getPublisherInfo',
      user: 'getUser'
    })
  },
  watch: {
    params: {
      handler(val) {
        val.emailLists.split(/[;\n ]/)
      }
    }
  },
  async mounted() {
    this.getPublisherInfo()
  },
  methods: {
    ...mapActions(['updatePublisherId', 'updatePublisherInfo']),

    async getPublisherInfo() {
      const publisherInfo = await publisher.query(this.publisherId || 'imr')
      this.params.emailList = publisherInfo.emailList
      this.params.emailLists = publisherInfo.emailList.split(/[;\n ]/)
    },
    async submit() {
      this.params.emailList = this.params.emailLists
        ? this.params.emailLists.join(';')
        : []
      if (this.params.emailList.length > 4096) {
        this.$message.error({
          title: 'Error',
          content: `The length of email list  is too long and must be less than 4096 bytes.`
        })
        return
      }
      const params = {
        id: this.publisherId || 'imr',
        emailList: this.params.emailList
      }
      await publisher.emailBlackList(this.publisherId || 'imr', params)
      this.$message.success({
        title: 'Success',
        content: 'Email Update Successful!'
      })
      this.isShow = !this.isShow
    }
  }
}
